import { Component } from '@angular/core';
import { AccountCenterService } from '../../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { PolicyLink, PolicyModal } from '../../../../../../coverpath-common/angular/interfaces/account-center/PolicyLink';
import { PolicyLinkConstructor } from '../../../classes/policy-links/PolicyLinkConstructor';
import { ModalService } from "../../../../../../coverpath-common/angular/services/modal/modal.service";
import { BasePolicyLinksComponent } from '../../../../../../coverpath-common/angular/components/account-center/policy-links/base-policy-links.component';

@Component({
    selector: 'policy-links',
    moduleId: module.id,
    templateUrl: './policy-links.component.html'
})
export class PolicyLinksComponent extends BasePolicyLinksComponent {

    showLinks: boolean;

    ngOnInit(): void {
        this.showLinks = !(this.accountCenterService.primaryPolicy.amorphicGetClassName() === 'LifeBridgePolicy');
        this.subscribeToAccountCenterService();
    }

    constructor(accountCenterService: AccountCenterService, amorphicService: AmorphicService, modalService: ModalService) {
        super(accountCenterService, amorphicService, modalService);
    }

    async constructLinksForPolicyMode(workflowAction: string): Promise<void> {
        const isPolicyHeld = await this.accountCenterController.getPAStatusIsPolicyHeld(this.accountCenterService.primaryPolicy.policyNumber);
        const specialHandling = await this.accountCenterController.getPAStatusSpecialHandling(
            this.accountCenterService.primaryPolicy.policyNumber
          );

        const ownerResidentialState = this.accountCenterService.primaryPolicy.ownerPersonResidentialAddress.state;
        this.topLinks = new Array<PolicyLink>();
        this.bottomLinks = new Array<PolicyLink>();
        this.topLinks.push(new PolicyLink('View Application PDF', this.accountCenterController.getViewApplicationURL()));
        this.topLinks.push(new PolicyLink('View Policy', this.accountCenterController.getViewPolicyAdminDocsURL('primary')));
        if (!isPolicyHeld && !specialHandling) {
            this.topLinks.push(new PolicyModal('Change Payment Method', 'bankInfo'));
            if(ownerResidentialState === 'MA'){
                this.topLinks.push(new PolicyLink('Change Beneficiary', PolicyLinkConstructor.createChangeBeneficiaryLink(ownerResidentialState)));
            }
            else {
                this.topLinks.push(new PolicyModal('Change Beneficiary', 'beneWidget'));
            }
        }
        else{
            this.topLinks.push(new PolicyLink('Change Payment Method', PolicyLinkConstructor.createBankAccountLink()));
            this.topLinks.push(new PolicyLink('Change Beneficiary', PolicyLinkConstructor.createChangeBeneficiaryLink(ownerResidentialState)));
         }
        this.topLinks.push(new PolicyLink('Change Owner', PolicyLinkConstructor.creatChangeOwnerLink()));
        if (!isPolicyHeld && !specialHandling) {
            this.topLinks.push(new PolicyModal('Update Contact Information', 'contactWidgetMmDirect'));
        }
        else {
            this.topLinks.push(new PolicyLink('Change Mailing Address', PolicyLinkConstructor.createMailingAddressLink()));
        }
        this.topLinks.push(new PolicyLink('Change Name', PolicyLinkConstructor.createChangeNameLink()));
        this.topLinks.push(new PolicyLink('Change Face Amount', PolicyLinkConstructor.createChangeFaceAmountLink()));
        if(/Pending Policy Docs/.test(workflowAction)) {
            // skip any cancellation link for these stages
        }
        else if(workflowAction && /In Force/.test(workflowAction) && !/Free Look Period/.test(workflowAction)){
            this.bottomLinks.push(new PolicyLink('Cancel Policy', PolicyLinkConstructor.createCancelViaDocusignLink()));
        }
        else{
            this.bottomLinks.push(new PolicyModal('Cancel Policy', 'cancelPolicySimple'));
        }
    }
}
